<body>
  <div>
    <div class="top-container">
      <div class="flex justify-content-between flex-wrap" style="margin-right: 8px; margin-bottom: 20px;">
        <div class="flex align-items-center justify-content-center m-3">
          <i class="pi pi-arrow-left" style="font-size: 1rem; cursor: pointer" (click)="goBack()"></i>
        </div>

        <div *ngIf="status === 'Rejected'" class="flex align-items-center justify-content-center m-2">
          <div class="m-0">
            <button pButton class="btn-1 btn-warning-1 outlined-1 small raised mr-3" (click)="showDeleteDialog()">Delete</button>
          </div>
          <!-- <div class="m-0">
            <button pButton class="btn-1 btn-primary btn-seconary-warning small raised" (click)="approve()">
              Approve
            </button>
          </div> -->
        </div>

        <div *ngIf="status === 'In Review'" class="flex align-items-center justify-content-center m-2">
          <div class="m-0">
            <button pButton class="btn-1 btn-warning-1 outlined-1 small raised mr-3" (click)="reject()">
                Reject
              </button>
          </div>
          <div class="m-0">
            <button pButton class="btn-1 btn-primary btn-seconary-warning small raised" (click)="approve()">
              Approve
            </button>
          </div>
        </div>
        <!-- Page header -->
        <div class="flex align-items-center justify-content-center m-2 top-content" *ngIf="status === 'Submitted'">
          <span class="m-0">
            <app-permission-wrapper permission="CanApproveRejectServiceProvider">
              <button pButton class="btn-1 btn-warning-1 outlined-1 small raised" (click)="reject()">
                Reject
              </button>
            </app-permission-wrapper>
          </span>
          <span class="m-0">
            <app-permission-wrapper permission="CanEditServiceProvider">
              <button pButton class="btn-2 small raised btn-contrast-1"
                [routerLink]="['edit-vehicle-service-provider']">
                Edit
              </button>
            </app-permission-wrapper>
          </span>
          <span class="m-0">
            <div class="container">
              <app-permission-wrapper permission="CanApproveRejectServiceProvider">
                <button pButton class="btn-1 btn-contrast-1 small raised" (click)="openReviewModal()">
                  Mark as review
                </button>
              </app-permission-wrapper>
            </div>
          </span>
          <span class="m-0">
            <app-permission-wrapper permission="CanApproveRejectServiceProvider">
              <button pButton class="btn-1 btn-primary btn-seconary-warning small raised" (click)="approve()">
                Approve
              </button>
            </app-permission-wrapper>
          </span>
        </div>
      </div>
      <!-- Section -->
      <div class="card-top">
        <!-- Map serviceProviderGalleries id here -->
        <img [src]="imgPath" class="image" />
        <div class="text" style="padding-left: 40px">
          <!-- Name of the service provider -->
          <div class="main-text">
            {{ truncatedServiceProviderName }}
          </div>
          <!-- address -->
          <div class="secondary-text" style="padding-top: 12px">
            {{ address }}
          </div>
          <!-- view Address proof -->
          <div>
            <div class="flex flex-row flex-wrap">
              <div class="flex align-items-center justify-content-center">
                <i class="pi pi-paperclip" style="font-size: 12px; color: #026aa2"></i>
              </div>
              <!-- Map serviceProviderDocuments
                                     which has documentTypeId 5 -->
              <div class="flex align-items-center justify-content-center m-1" style="
                  font-size: 14px;
                  color: #026aa2;
                  line-height: 20px;
                  cursor: pointer;
                " (click)="viewAddressProof()">
                View Address proof
              </div>
            </div>
          </div>
          <div style="width: 497px">
            <div class="row-container">
              <div class="business-details">
                <div class="owner">Business Owner</div>
                <div class="user-info">
                  <div class="icon-circle">
                    <i class="user-icon pi pi-user" style="color: #708090"></i>
                  </div>
                  <div class="username ml-2">
                    <p class="name">{{ name }}</p>
                    <p class="email">{{ ownerPhoneNumber }}</p>
                  </div>
                </div>
                <div style="cursor: pointer">
                  <div (click)="viewOwnerIdProof()" style="width: 130px; margin-top: 12px"
                    class="flex justify-content-start flex-wrap">
                    <i class="flex align-items-center justify-content-center pi pi-paperclip mr-1"
                      style="font-size: 14px; color: #026aa2">
                    </i>
                    <!-- Map owner Id proof here from
                                             serviceProviderDocuments which ha documentTypeId 7 -->
                    <div class="flex align-items-center justify-content-center"
                      style="font-size: 14px; color: #026aa2; line-height: 20px">
                      View ID proof
                    </div>
                  </div>
                </div>
              </div>
              <div class="divider"></div>
              <div style="margin-top: 65px; margin-left: 52px">
                <div class="owner">Incharge Details</div>
                <div class="user-info">
                  <div class="icon-circle">
                    <i class="user-icon pi pi-user" style="color: #708090"></i>
                  </div>
                  <div class="username ml-2">
                    <p class="name">{{ garageInChargeName }}</p>
                    <p class="email">{{ garageInChargePhoneNumber }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div style="cursor: pointer" (click)="viewInchargeIdProof()">
              <div style="width: 130px; margin-top: 5px; margin-left: 288px"
                class="flex justify-content-start flex-wrap">
                <i class="flex align-items-center justify-content-center pi pi-paperclip mr-1"
                  style="font-size: 14px; color: #026aa2">
                </i>
                <!-- Map garage incharge documents from
                                     serviceProviderDocuments which has documentTypeId 8-->
                <div class="flex align-items-center justify-content-center"
                  style="font-size: 14px; color: #026aa2; line-height: 20px">
                  View ID proof
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="history-container">

          <div class="history" (click)="displayHistory()">
            <p-button icon="pi pi-history" label="History" [rounded]="true" [text]="true" size="small" />
          </div>
          <!-- <p-dialog [(visible)]="visibleHistory" header="History" [style]="{ width: '420px', 'border-radius': '12px' }">
            <p-timeline [value]="events">
              <ng-template pTemplate="content" let-event>
                <small class="p-text-secondary">{{
                  event.createdBy?.name || "ABC"
                  }}</small><br />
                <small class="p-text-secondary">{{
                  event.createdOn | date
                  }}</small>
              </ng-template>
              <ng-template pTemplate="opposite" let-event>
                {{ event.status }}
              </ng-template>
              <ng-template pTemplate="opposite" let-event>
                {{ event.status }}
              </ng-template>
            </p-timeline>
          </p-dialog> -->

          <p-dialog [(visible)]="visibleHistory" header="History" [style]="{ width: '600px', 'border-radius': '12px' }">
            <p-timeline [value]="events">
              <ng-template pTemplate="content" let-event>
                <small class="p-text-secondary">
                  <strong> {{ event.status }} </strong>
                  {{
                  event.createdBy?.name || ''
                  }}</small>
                <small class="p-text-secondary">{{
                  event.createdOn | date
                  }}</small>
              </ng-template>
            </p-timeline>
            <ng-template pTemplate="footer">
              <button pButton type="button" label="OK" (click)="visibleHistory = false" class="btn-primary"></button>
            </ng-template>
          </p-dialog>

          <div class="flex justify-content-center flex-wrap p-1">
            <span class="tag" [ngClass]="{
                submitted: status === 'Submitted',
                approved: status === 'Approved',
                inreview: status === 'In Review',
                rejected: status === 'Rejected'
              }">{{ status }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="main-part">
      <div style="padding-left: 49px">
        <p style="font-weight: 500; font-size: 18px; margin-bottom: 40px">
          Business Details
        </p>
        <div class="flex justify-content-start flex-wrap">
          <div class="">
            <div style="width: 225px">
              <p class="business-type-label">Business type</p>
              <p class="business-type-value">{{ businessType }}</p>
            </div>
            <div class="business-info">
              <p class="business-type-label">Submited by</p>
              <p class="business-type-value" pTooltip="{{ applicantEmailAddress }}" tooltipPosition="top">
                {{ submittedBy }}({{ truncatedEmail }})
              </p>
            </div>
          </div>
          <div style="width: 225px; padding-left: 52px">
            <div>
              <p class="business-type-label">GST Number</p>
              <p class="business-type-value">{{ gst }}</p>
            </div>
            <div class="business-info">
              <p class="business-type-label">Submited on</p>
              <p class="business-type-value">{{ date | date }}</p>
            </div>
          </div>
          <div style="width: 225px; padding-left: 52px">
            <div>
              <p class="business-type-label">Year of commencement</p>
              <div style="cursor: pointer">
                <div class="flex flex-row flex-wrap">
                  <p class="business-type-value">{{ commencementYear }}</p>
                  <div class="flex align-items-center justify-content-center ml-2">
                    <i class="pi pi-paperclip" style="font-size: 14px; color: #026aa2">
                    </i>
                  </div>
                  <!-- Certificate of incorporation documents here from serviceProviderDocuments which has documentTypeId 6-->
                  <div class="flex align-items-center justify-content-center ml-1"
                    style="font-size: 14px; color: #026aa2; line-height: 20px" (click)="viewCOIProof()">
                    View proof
                  </div>
                </div>
              </div>
            </div>
            <div class="business-info">
              <p class="business-type-label">Application ID</p>
              <p class="business-type-value">{{ applicationId }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- subscriptions(will sealt in future) -->
    <!-- <div class="main-part">
      <div style="padding-left: 49px">
        <p style="font-weight: 500; font-size: 18px; margin-bottom: 40px">
          Subscription Plan
        </p>
        <div class="flex justify-content-start flex-wrap">
          <div style="width: 225px">
            <div>
              <p class="business-type-label">Plan name</p>
              <p class="business-type-value">{{ planName }}</p>
            </div>
            <div class="business-info">
              <p class="business-type-label">Add ons</p>
              <p class="business-type-value">---</p>
            </div>
          </div>
          <div style="width: 225px; padding-left: 52px">
            <div>
              <p class="business-type-label">Amount paid</p>
              <p class="business-type-value">{{ paidAmount }}</p>
            </div>
            <div class="business-info"></div>
          </div>
          <div style="width: 225px; padding-left: 52px">
            <div>
              <p class="business-type-label">Invoice</p>
              <div style="cursor: pointer">
                <div class="flex flex-row flex-wrap">
                  <div class="flex align-items-center justify-content-center">
                    <i class="pi pi-download" style="font-size: 14px; color: #026aa2">
                    </i>
                  </div>
                 
                  <div class="flex align-items-center justify-content-center ml-1"
                    style="font-size: 14px; color: #026aa2; line-height: 20px">
                    Download
                  </div>
                </div>
              </div>
            </div>
            <div class="business-info"></div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="main-part">
      <div style="padding-left: 49px">
        <p style="font-weight: 500; font-size: 18px; margin-bottom: 40px">
          Services
        </p>
        <div class="service-container">
          <div *ngFor="let item of displayedServices">
            <span class="icon-circle-1">
              <i class="pi pi-check" style="color: #12b76a; font-size: 9px; font-weight: 900"></i>
            </span>
            <span class="service-name m-1">{{ item }}</span>
          </div>
        </div>
        <div *ngIf="serviceName && serviceName.length > 4" style="margin-top: 10px">
          <button class="btn-toggle" (click)="toggleShowAllServices()">
            {{ showAllServices ? "Show Less" : "Show More" }}
          </button>
        </div>
      </div>
    </div>

    <div class="main-part">
      <div style="padding-left: 49px">
        <p style="font-weight: 500; font-size: 16px; margin-bottom: 40px">
          Employee Details ({{ getTotalTechnicians() }})
        </p>
        <div class="flex justify-content-start flex-wrap">
          <div *ngFor="let technician of serviceProviderTechnicians" style="width: 245px">
            <div>
              <p class="business-type-label">{{ technician.technicianName }}</p>
              <p class="employee-value">{{ technician.noOfTechnician }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p-dialog [(visible)]="reviewModal" modal="true" [closable]="true" [style]="{ width: '600px' }"
      [baseZIndex]="10000">

      <ng-template pTemplate="header">
        <span class="review-heading">Mark for Review</span>
      </ng-template>

      <app-review-modal [resourceTypeLabel]="'Service provider'" (closeModal)="closeReviewModal()"
        [resourceType]="'SERVICEPROVIDER'" (onReviewSuccess)="markForReview()"></app-review-modal>

    </p-dialog>

    <div>
      <p-dialog [(visible)]="visible" modal="true" [closable]="true" [style]="{ width: '800px' }" [baseZIndex]="10000">

        <ng-template pTemplate="header">
          <span class="review-heading">Approve Application </span>
        </ng-template>

        <app-custom-dialog (closeModal)="closeApproveModal()" (refreshList)="refreshDetails()"
          [resourceType]="'SERVICEPROVIDER'" [serviceProviderName]="serviceProviderName"></app-custom-dialog>

      </p-dialog>
    </div>
    <div>
      <p-dialog [(visible)]="visibleReject" modal="true" [closable]="true" [style]="{ width: '600px' }"
        [baseZIndex]="10000">

        <ng-template pTemplate="header">
          <span class="review-heading"> Reject Application </span>
        </ng-template>

        <app-reject-modal [resourceType]="'SERVICEPROVIDER'" (closeModal)="closeRejectModal()"
          (refreshList)="getServiceProviderDetailsById()"
          (updateServiceProviderList)="closeRejectModal()"></app-reject-modal>

      </p-dialog>
    </div>

    <p-dialog [(visible)]="visibleViewer" [maximizable]="true" [modal]="true"
      [style]="{ width: '90vw', height: '90vh' }" [closable]="true" (onHide)="closeViewer()">
      <ng-template pTemplate="header">
        <div class="flex align-items-center">
          <span class="font-bold text-lg">Document Viewer</span>
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <div class="flex justify-content-center align-items-center" style="height: 100%;">
          <!-- PDF Viewer -->
          <ngx-extended-pdf-viewer *ngIf="selectedDocumentUrl && isPdf(selectedDocumentUrl)" [src]="selectedDocumentUrl"
            [height]="'100%'" [showSidebarButton]="false" [textLayer]="true" [showHandToolButton]="true"
            [showDownloadButton]="true" [showPrintButton]="true" [showSecondaryToolbarButton]="false"
            [showRotateButton]="true" [showToolbar]="true" style="width: 100%;">
          </ngx-extended-pdf-viewer>

          <!-- Image Viewer -->
          <div *ngIf="selectedDocumentUrl && !isPdf(selectedDocumentUrl)" class="image-viewer-container">
            <img [src]="selectedDocumentUrl" alt="Document Image" class="document-image" />
            <div class="image-toolbar">
              <button pButton icon="pi pi-download" label="Download" (click)="downloadImage()"></button>
              <button pButton icon="pi pi-times" label="Close" (click)="closeViewer()" class="ml-2"></button>
            </div>
          </div>
        </div>
      </ng-template>
    </p-dialog>

  </div>
</body>
<div>
  <app-add-sp *ngIf="showModal" [id]="idToEdit" (closeDialog)="showModalW()"></app-add-sp>
</div>

<p-dialog
  header="Confirm Deletion"
  [(visible)]="visibleDelete"
  modal="true"
  [closable]="true"
  [style]="{ width: '600px' }"
  [baseZIndex]="10000"
>
  <p>Are you sure you want to delete?</p>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancel"  (click)="visibleDelete = false" class="btn btn-cancel"></button>
    <button pButton type="button" label="Delete"  (click)="delete()" class="btn delete-btn "></button>
  </ng-template>
</p-dialog>